import React from 'react';
import Icon from '../../../components/AppIcon';

const KPICard = ({ title, value, change, changeType, icon, color = 'primary' }) => {
  const getChangeIcon = () => {
    if (changeType === 'increase') return 'TrendingUp';
    if (changeType === 'decrease') return 'TrendingDown';
    return 'Minus';
  };

  const getChangeColor = () => {
    if (changeType === 'increase') return 'text-success';
    if (changeType === 'decrease') return 'text-error';
    return 'text-muted-foreground';
  };

 const formatValue = (val) => {
  if (typeof val === 'number') {
    if (val >= 10000000) {
      return `₹${(val / 10000000).toFixed(1)}Cr`; // Crores
    } else if (val >= 100000) {
      return `₹${(val / 100000).toFixed(1)}L`; // Lakhs
    } else if (val >= 1000) {
      return `₹${(val / 1000).toFixed(0)}K`; // Thousands
    }
    return `₹${val.toLocaleString("en-IN")}`;
  }
  return val;
};


  return (
    <div className="bg-card border border-border rounded-lg p-6 hover:shadow-md transition-shadow duration-200">
      <div className="flex items-center justify-between mb-4">
        <div className={`w-12 h-12 rounded-lg bg-${color}/10 flex items-center justify-center`}>
          <Icon name={icon} size={24} className={`text-${color}`} />
        </div>
        <div className={`flex items-center space-x-1 ${getChangeColor()}`}>
          <Icon name={getChangeIcon()} size={16} />
          <span className="text-sm font-medium">{Math.abs(change)}%</span>
        </div>
      </div>
      
      <div className="space-y-1">
        <h3 className="text-sm font-medium text-muted-foreground">{title}</h3>
        <p className="text-2xl font-bold text-foreground">{formatValue(value)}</p>
      </div>
    </div>
  );
};

export default KPICard;